import { call, put } from 'redux-saga/effects';

import { getUserProfile } from '../../services/user';
import { requestUserProfileError, requestUserProfileSuccess } from './actions';
import { UserLogout } from '../auth/actions';
import { AuthActionTypes } from '../auth/types';
import { StatusKeys } from '@/constants';

export function* fetchProfileUser(): any {
  const payloadUserProfile = yield call(getUserProfile);
  if (payloadUserProfile.success) {
    const { data } = payloadUserProfile;
    if (data.status === StatusKeys.Inactive) {
      yield put(UserLogout());
    }
    yield put(requestUserProfileSuccess(payloadUserProfile.data));
  } else {
    yield put({ type: AuthActionTypes.USER_LOGOUT });
    yield put(requestUserProfileError(payloadUserProfile));
  }
}

export const userProfile = () => {
  const roleUser = window.localStorage.getItem('role');
  return roleUser;
};
